import React from "react";
import styles from "./PageBanner1.module.css";
import { Link } from "react-router-dom";
const PageBanner1 = ({ image, title }) => {
  return (
    <div className={styles["page-banner"]}>
      <img src={image} alt={title} className={styles["banner-img"]} />
      <div className={styles["banner-overlay"]}>
        <div className={styles.textBlock}>
          <h1>
            "Trusted Legal Expertise. Strategic Solutions. Lasting Impact."
          </h1>
          {/*  <p>
            Providing trusted legal advice and representation with integrity,
            professionalism, and care.
          </p> */}
          <Link to="/contact" className={styles.ctaButton}>
            For Further Information
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageBanner1;
